import { StyleSheet } from '../../../utils/style/types';

const styles: StyleSheet = {
  avatarBoxMobile: {
    display: {
      mobile: 'flex',
      desktop: 'none',
    },
    margin: {
      desktop: '0 auto 12px auto',
      mobile: '0 auto 24px auto',
    },
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarBoxDesktop: {
    display: {
      mobile: 'none',
      desktop: 'flex',
    },
    margin: {
      desktop: '0 auto 12px auto',
      mobile: '0 auto 24px auto',
    },
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  profileCard: {
    border: 'none',
    boxShadow: 'none',
    margin: '0 auto',
    padding: '0',
    width: {
      desktop: '662px',
      mobile: '100%',
    },
  },
  profileSkeleton: {
    margin: '0 auto',
    height: '44px',
    width: '100%',
  },
};

export default styles;
